var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClear = function SvgClear(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 7.5,
    fill: "#8382CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19375 6.69373C5.93544 6.95204 5.93544 7.37084 6.19375 7.62915L8.06463 9.50003L6.19373 11.3709C5.93542 11.6292 5.93542 12.048 6.19373 12.3064C6.45204 12.5647 6.87084 12.5647 7.12915 12.3064L9.00005 10.4355L10.8708 12.3062C11.1291 12.5645 11.5479 12.5645 11.8063 12.3062C12.0646 12.0479 12.0646 11.6291 11.8063 11.3708L9.93547 9.50003L11.8062 7.62926C12.0645 7.37096 12.0645 6.95216 11.8062 6.69385C11.5479 6.43554 11.1291 6.43554 10.8708 6.69385L9.00005 8.56462L7.12917 6.69373C6.87086 6.43542 6.45206 6.43542 6.19375 6.69373Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear.b4012e11.svg";
export { ForwardRef as ReactComponent };